import Text from '@atoms/Text/Text';
import { IShareButton } from '@models/IShareButton';
import ShareButton from '@molecules/ShareButton/ShareButton';

export interface IArticleStamp {
  readonly date: string;
  readonly timeStamp: string;
  readonly showPublishedDate: boolean;
  readonly shareButton: IShareButton;
}

const ArticleStamp = ({
  date,
  timeStamp,
  shareButton,
  showPublishedDate,
}: IArticleStamp) => (
  <section className="tw-my-[60px] tw-flex tw-w-full tw-border-b tw-border-grey-20 tw-pb-4 md:tw-my-20">
    <div className="tw-flex  tw-gap-6 tw-py-[5px] tw-text-grey-70">
      {showPublishedDate && date && (
        <Text variant="body-small" className="tw-uppercase">
          {date}
        </Text>
      )}
      {timeStamp && showPublishedDate && date && (
        <span className="tw-h-4 tw-w-[1px] tw-bg-grey-20" />
      )}
      <Text variant="body-small">{timeStamp}</Text>
    </div>
    <div className="tw-ml-auto">
      <ShareButton {...shareButton} />
    </div>
  </section>
);

export default ArticleStamp;
